export class CustCard_4 {
    registrationDate?:string;
    lastDateVisitStr?:string;
}

